
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'

export default {
  components: { StoryblokComponent },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.gridRow = this.getBreakpointValue(this.blok?.gridRow)
      styles.gridColumn = this.getBreakpointValue(this.blok?.gridColumn)
      styles.maxWidth = this.getBreakpointValue(this.blok?.maxWidth)
      styles.placeSelf = this.getBreakpointValue(this.blok?.placeSelf)
      styles.margin = this.getBreakpointValue(this.blok?.margin)
      styles.padding = this.getBreakpointValue(this.blok?.padding)
      styles.width = this.getBreakpointValue(this.blok?.width)

      return styles
    },
  },
}
